import { Tooltip } from '@mantine/core';
import { NavLink } from 'react-router-dom';

import NewsIcon from '@/assets/icons/content/m-updates.svg';
import { POSTHOG_EVENTS } from '@/lib/posthog/events';
import { trackEvent } from '@/lib/posthog/helpers';

import classes from './Navbar.module.css';

const News = ({ desktopOpened }: { desktopOpened: boolean }) => (
  <NavLink
    to="/news"
    className={({ isActive }) => `${classes.footerNavRow} ${isActive ? classes.active : ''}`}
    aria-label="Mercury Updates"
    onClick={() => trackEvent(POSTHOG_EVENTS.NEWS_OPEN, { source: 'sidebar' })}
  >
    <Tooltip
      arrowOffset={10}
      arrowSize={4}
      label="Mercury Updates"
      position="right"
      offset={40}
      color="var(--active-color)"
      disabled={desktopOpened}
      visibleFrom="sm"
      transitionProps={{ duration: 0 }}
      withArrow
    >
      <span className={classes.footerNavIcon}>
        <NewsIcon width={20} height={20} />
      </span>
    </Tooltip>

    <span className={classes.toggleLabel}>Mercury Updates</span>
  </NavLink>
);

export default News;
